import {
  HubConnectionBuilder,
  LogLevel,
  HubConnectionState,
  HubConnection,
} from '@microsoft/signalr';

import { configureSubscriptions } from '../util/eventSubscriptions';
import actionTypes from '../constants/actionTypes';
import { createAction, Middleware } from '@reduxjs/toolkit';
import { setConnectedUsers } from '../reducers/connectedUsersReducer';

export const addToGroup = createAction<string>('signalR/addToGroup');
export const removeFromGroup = createAction<string>('signalR/removeFromGroup');
export const pageActive = createAction('signalR/pageActive');
export const pageInactive = createAction('signalR/pageInactive');
export const getConnectedUsers = createAction('signalR/getConnectedUsers');

const startSignalRConnection = async (connection: HubConnection) => {
  try {
    await connection.start();
    console.log('SignalR connected');
  } catch (err) {
    console.error('SignalR connection error: ', err);
    setTimeout(() => startSignalRConnection(connection), 5000);
  }
};

const signalRMiddleware: Middleware = ({ dispatch, getState }) => {
  let connection: HubConnection | undefined;

  const connectionHub =
    window.globalConfig?.hubUrl ?? process.env.REACT_APP_HUB_URL;

  return (next) => async (action: any) => {
    switch (action.type) {
      case actionTypes.USER_SIGNED_IN:
        if (connection?.state === HubConnectionState.Connected) {
          console.log('Signalr connection already exists and is connected');
          return;
        }

        // create the connection instance
        connection = new HubConnectionBuilder()
          .withUrl(`${connectionHub}/hub/notificationhub`, {
            accessTokenFactory: () => action.payload.access_token,
          })
          .configureLogging(LogLevel.Critical)
          .withAutomaticReconnect()
          .build();

        configureSubscriptions(connection, dispatch);

        // Connection event handlers
        connection.onclose(() => {
          console.log('SignalR connection closed');
        });

        connection.onreconnecting(() => {
          console.log('SignalR attempting to reconnect');
        });

        connection.onreconnected(() => {
          console.log('SignalR reconnected successfully');
        });

        startSignalRConnection(connection);
        break;
      case actionTypes.ADD_TO_GROUP:
        connection?.state === 'Connected' &&
          connection.invoke('AddToGroupAsync', action.payload);
        break;
      case actionTypes.REMOVE_FROM_GROUP:
        connection?.state === 'Connected' &&
          connection.invoke('RemoveFromGroupAsync', action.payload);
        break;
      case actionTypes.GET_CONNECTED_USERS:
        if (connection) {
          connection
            .invoke('GetConnectedUsers')
            .then(function (users) {
              console.log('returned users', users);
              dispatch(setConnectedUsers(users));
            })
            .catch(() => {});
        }
        break;
      case actionTypes.PAGE_ACTIVE:
        connection?.state === 'Connected' && connection.invoke('PageActive');
        break;
      case actionTypes.PAGE_INACTIVE:
        connection?.state === 'Connected' && connection.invoke('PageInactive');
        break;
      default:
        break;
    }
    return next(action);
  };
};

export default signalRMiddleware;
